import mockArticleResponse from './json/article.json';
import mockSearchFullRelatedItemsResponse from './json/related-items.json';
import mockScenarioResponse from './json/scenario.json';
import mockSearchFullBreadcrumbResponse from './json/search-full.json';
import mockTopicResponse from './json/topic.json';
import mockTreeBranchViewResponse from './json/tree-branch-view.json';
import mockScenarioRootResponse from './json/tree-branch-view.json';

export const ARTICLES = {
  data: {
    items: [
      {
        id: 1771,
        externalId: null,
        type: 'DOCUMENT',
        subType: 'T_HOW_TO',
        title: 'Learn about and set up your GFiber Wi-Fi 6E Router',
        titleSearch: null,
        templateTitle: 'How to and Troubleshooting',
        shortDescription: null,
        alias: null,
        hits: 2,
        isCountHits: true,
        rank: 0,
        rating: 0,
        ratingNumber: 0,
        statusFromDate: 1725991200000,
        statusToDate: null,
        updateDate: 1728127195000,
        activeVersionNumber: 1,
        showSearchResult: true,
        revision: 32,
      },
    ],
    total: 2766,
  },
  statusCode: 200,
};

export const TOPICS = {
  data: {
    items: [
      {
        id: 987,
        externalId: null,
        type: 'FOLDER',
        subType: 'LIST',
        title: 'Advanced Networking Concepts',
        titleSearch: null,
        templateTitle: 'Folder',
        shortDescription: null,
        alias: null,
        hits: 1,
        isCountHits: true,
        rank: 0,
        rating: 0,
        ratingNumber: 0,
        statusFromDate: 1725217500000,
        statusToDate: null,
        updateDate: 1728818280000,
        activeVersionNumber: 1,
        showSearchResult: true,
        revision: 4,
      },
    ],
    total: 442,
  },
  statusCode: 200,
};
export const SCENARIOS = {
  data: {
    items: [
      {
        id: 1109,
        externalId: null,
        type: 'DOCUMENT',
        subType: 'SCENARIO',
        title: 'T- Troubleshooting your Google Fiber Phone',
        titleSearch: 'version1en',
        templateTitle: 'Scenario',
        shortDescription: null,
        alias: 'FLOW',
        hits: 2,
        isCountHits: true,
        rank: 0,
        rating: 0,
        ratingNumber: 0,
        statusFromDate: 1725207840000,
        statusToDate: null,
        updateDate: 1727720159000,
        activeVersionNumber: 1,
        showSearchResult: true,
        revision: 4,
      },
    ],
    total: 2766,
  },
  statusCode: 200,
};

export function getMockPublicItem(itemId: string, language: string) {
  if (itemId === '1771') {
    return mockArticleResponse;
  }
  if (itemId === '987') {
    return mockTopicResponse;
  }
  if (itemId === '1109') {
    return mockScenarioResponse;
  }
  return {
    id: Number(itemId),
    language,
    title: '',
    description: '',
  };
}

export function getMockSearchFull(type: string) {
  if (type === 'breadCrumb') {
    return mockSearchFullBreadcrumbResponse;
  }
  if (type === 'related-items') {
    return mockSearchFullRelatedItemsResponse;
  }
  return {};
}

export function getMockTreeBranchView() {
  return mockTreeBranchViewResponse;
}

export function getMockScenarioRoot() {
  return mockScenarioRootResponse;
}
